export class Accessory {
    constructor(public AcsID?, public AcsN?) { }
}